module.exports = __webpack_public_path__ + "img/video_logo.1bf5a4e2.jpg";